import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFormatBold$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatBold extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '782f133b08f8a2a1ecc6f31a6c48aab436acfaf0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b2ddb5bbed730dd3614695cad4ad25f4015fa087', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd3c35ca9bfcc2c49b3aeb8aa82d5b54023ec6163', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 14.13c0 2.39-1.69 3.87-4.37 3.87H6.5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4.65c2.66 0 4.26 1.37 4.26 3.66a3.51 3.51 0 0 1-1.33 3A3.51 3.51 0 0 1 16 14.13M9 6.56v3h1.8c1.11 0 1.75-.45 1.75-1.47s-.58-1.48-1.71-1.48zm2.12 8.88c1.27 0 2-.56 2-1.73s-.75-1.65-2-1.65H9v3.38z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-format-bold", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-bold"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-bold":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatBold$1);
            }
            break;
    } });
}

const CosmosIconFormatBold = CosmosIconFormatBold$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatBold, defineCustomElement };
